'use es6';

import PropTypes from 'prop-types';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { connect } from 'react-redux';
import { replaceFile } from '../../actions/Files';
import { getModalDisplayMeta, getReplaceFiles, getSelectedFolderOrFile } from '../../selectors/ModalDisplay';
import { closeModal } from '../../actions/Actions';
import FileUsage from '../FileUsage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { MODAL_WIDTH } from 'FileManagerCore/Constants';
import { getIsFileAccessibleAnonymously } from 'FileManagerCore/utils/fileAccessibility';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getKey = suffix => `FileManagerCore.confirmReplacemodal.${suffix}`;
const ReplaceFileWarning = ({
  file,
  files,
  dispatch,
  modalDisplayMeta
}) => /*#__PURE__*/_jsx(UIConfirmModal, {
  message: /*#__PURE__*/_jsx(FormattedMessage, {
    message: getKey('message'),
    options: {
      fileName: file.get('name')
    }
  }),
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: getKey('description'),
      options: {
        fileName: file.get('name')
      }
    }), getIsFileAccessibleAnonymously(file) && /*#__PURE__*/_jsx(FileUsage, {
      usage: modalDisplayMeta.get('usage'),
      hasRequestFailed: false,
      forDeleteModal: false
    })]
  }),
  confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: getKey('confirm')
  }),
  onConfirm: () => {
    dispatch(replaceFile(file, files[0]));
    dispatch(closeModal());
  },
  rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: getKey('cancel')
  }),
  onReject: () => dispatch(closeModal()),
  size: "auto",
  use: "success",
  width: MODAL_WIDTH,
  "data-test-id": "replace-file-confirm-modal"
});
ReplaceFileWarning.propTypes = {
  file: PropTypes.instanceOf(Immutable.Map).isRequired,
  files: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  modalDisplayMeta: PropTypes.instanceOf(Immutable.Map).isRequired
};
const mapStateToProps = state => ({
  files: getReplaceFiles(state),
  file: getSelectedFolderOrFile(state),
  modalDisplayMeta: getModalDisplayMeta(state)
});
export default connect(mapStateToProps)(ReplaceFileWarning);